module.exports = __webpack_public_path__ + "bbb4ddb50e3d82e8622edbfa66f5a93e.MP3";